/**
 * Analytics API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ReportType = 'hour' | 'day' | 'week' | 'month' | 'year';

export const ReportType = {
    Hour: 'hour' as ReportType,
    Day: 'day' as ReportType,
    Week: 'week' as ReportType,
    Month: 'month' as ReportType,
    Year: 'year' as ReportType
};

